import Vue from 'vue';
import { ModalPlugin, ToastPlugin, SpinnerPlugin, PopoverPlugin, TablePlugin, TooltipPlugin } from 'bootstrap-vue';

Vue.use(ModalPlugin);
Vue.use(ToastPlugin);
Vue.use(SpinnerPlugin);
Vue.use(PopoverPlugin);
Vue.use(TablePlugin);
Vue.use(TooltipPlugin);
